import { useCallback, useEffect, useRef } from 'react';
export function useAccessibleOnChange(onChange, name, type, ref) {
    const savedOnChange = useRef(onChange);
    useEffect(() => {
        savedOnChange.current = onChange;
    });
    const handleChange = useCallback((_value) => {
        var _a;
        const checked = typeof _value === 'string' ? false : _value;
        const value = typeof _value === 'boolean' ? name : _value;
        const target = (_a = ref === null || ref === void 0 ? void 0 : ref.current) !== null && _a !== void 0 ? _a : {
            value,
            name,
            type,
            checked,
            files: null,
        };
        const event = { target, currentTarget: target };
        savedOnChange.current(event);
    }, [name, type, ref]);
    return handleChange;
}
//# sourceMappingURL=useAccessibleOnChange.js.map